import { render, staticRenderFns } from "./CompetenceCreateDialog.vue?vue&type=template&id=df92d1e8"
import script from "./CompetenceCreateDialog.vue?vue&type=script&lang=js"
export * from "./CompetenceCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports